import React from "react";
import { Link } from 'react-router-dom';
import "../../styles/common/Footer.css";
import logo from '../../assets/images/logo.svg';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <img src={logo} alt="LCS Logo" className="footer-logo-img" />
            <p className="footer-tagline">
              India's Leading KYC Verification Services Provider
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/" target="_blank" rel="noopener noreferrer">Home</Link></li>
              <li><Link to="/industries" target="_blank" rel="noopener noreferrer">Industries</Link></li>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">Services</Link></li>
              <li><Link to="/how-it-works" target="_blank" rel="noopener noreferrer">How It Works</Link></li>
              <li><Link to="/about-us" target="_blank" rel="noopener noreferrer">About Us</Link></li>
              <li><Link to="/career" target="_blank" rel="noopener noreferrer">Career</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">Fraud analysts</Link></li>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">Instant business verification</Link></li>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">Age Verification</Link></li>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">Document verification</Link></li>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">PAN Verification</Link></li>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">Court Case Check</Link></li>
              <li><Link to="/services" target="_blank" rel="noopener noreferrer">KYC Verification</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Legal & Compliance</h4>
            <ul>
              <li><Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link></li>
              <li><Link to="/terms-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link></li>
              <li><Link to="/faq" target="_blank" rel="noopener noreferrer">FAQ</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Us</h4>
            <ul>
              <li><i className="fas fa-envelope"></i> <a href="mailto:sales@lcsolution.in">sales@lcsolution.in</a></li>
            </ul>
            <Link to="/contact" className="btn-footer-contact" target="_blank" rel="noopener noreferrer">Get Started</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">&copy; {currentYear} Local Infotech Solution System. All rights reserved..</p>
          <p className="footer-disclaimer">
            We follow all applicable MCA guidelines and data protection laws. We are not a lending institution. KYC Verification approval depends on lender policies.
          </p>
        </div>
      </div>
    </footer>
  );
}

